import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
function addLink(rel: string, href: string, extra: Partial<HTMLLinkElement> = {}): HTMLLinkElement {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.assign(link, extra);
  document.head.appendChild(link);
  return link;
}

// Warm up the connections this page actually needs before anything requests them.
addLink("preconnect", "https://cdn.magicpatterns.com");
addLink("preconnect", "https://fonts.googleapis.com");
addLink("preconnect", "https://fonts.gstatic.com", {
  crossOrigin: "anonymous"
});

// Load Google Fonts without blocking the initial render: fetch the stylesheet
// as a low-priority preload, then flip it to an active stylesheet once ready.
// This keeps the font request off the critical rendering path entirely.
const fontsHref = "https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Inter:wght@400;500;600;700&display=swap";
const fontPreload = addLink("preload", fontsHref, {
  as: "style"
});
fontPreload.onload = () => {
  fontPreload.onload = null;
  fontPreload.rel = "stylesheet";
};
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-379" data-mp="10pvk71fiz8fh" />);
}